import { jsx as _jsx } from "react/jsx-runtime";
export function UsersAdminPage() {
    return _jsx("div", { children: _jsx("h1", { children: "User Management" }) });
}
//# sourceMappingURL=users-admin-page.js.map